import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Features from "./features/Features";
import Landing from "./landing/Landing";
import "./Content.css";
import Changelog from "./features/changelog/Changelog";
import Versioning from "./features/versioning/Versioning";
import Start from "./start/Start";
import CISnippet from "./start/ci-snippet/CISnippet";
import IncrementTags from "./start/increment-tags/IncrementTags";
import CommitTags from "./start/commit-tags/CommitTags";

function Content() {
  const location = useLocation();

  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransistionStage] = useState("fadeIn");

  useEffect(() => {
    if (location !== displayLocation) setTransistionStage("fadeOut");
  }, [location, displayLocation]);

  return (
    <div
      className={`${transitionStage}`}
      onAnimationEnd={() => {
        if (transitionStage === "fadeOut") {
          setTransistionStage("fadeIn");
          setDisplayLocation(location);
        }
      }}
    >
      <Routes location={displayLocation}>
        <Route path="/GitVersioniser" element={<Landing />} />
        <Route path="/GitVersioniser/start" element={<Start />} />
        <Route path="/GitVersioniser/features" element={<Features />} />
        <Route path="/GitVersioniser/changelog" element={<Changelog />} />
        <Route path="/GitVersioniser/versioning" element={<Versioning />} />
        <Route path="/GitVersioniser/ci-snippet" element={<CISnippet />} />
        <Route path="/GitVersioniser/commit-tags" element={<CommitTags />} />
        <Route path="/GitVersioniser/increment-tags" element={<IncrementTags />} />
      </Routes>
    </div>
  );
}

export default Content;
